import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';

export default class LpClassic extends BaseLP {
    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
        dispatch(Action.do('createGroupsOfTeamStacks', preparedPlayers.groupedBy.property('team')));
    }

    subjectToPermanent() {
        const constraints = {
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {checkIfPlayerOnDoublePosition: true}, ''),
            projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {checkIfPlayerOnDoublePosition: true}, ''),
            positions: this.exec('positions', {unitIdPropName: 'uniqueId'}, ''),
            games: this.exec('prepareSectionByGame', {addPositionToPID: true}, ''),
            keyPlayerStacking: this.exec('keyPlayerStacking', {checkIfPlayerOnDoublePosition: true}, ''),
            teamNameStacking: this.exec('teamNameStacking', {checkIfPlayerOnDoublePosition: true}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {checkIfPlayerOnDoublePosition: true}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {checkIfPlayerOnDoublePosition: true, unitIdPropName: 'uniqueId'}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            multiPositions: this.exec('prepareSectionByMultiPositions', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {checkIfPlayerOnDoublePosition: true}, ''),
        };

        return {...constraints};
    }
}
